import React from "react";
import { formatPriceIntl } from "../../../../../../../common-deprecated/priceUtils";
import { useCarConfigSelector } from "../../../../redux/store";
import Text from "../../../../../shared-components/css-modules/lexus/atoms/Text";
import styles from "../header/Cta.module.scss";
import { CarConfigLabel } from "../../../../utils/labelUtils";

const ExchangeRate = (): JSX.Element => {
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);

    const { primaryPrice, secondaryPrice } = formatPriceIntl(
        commonSettings,
        1,
        { currencyDisplay: "code" },
        true,
        undefined,
        // as secondary value is not really a price that needs to take in
        // account maximumFractionDigits from commonSettings, we set it to max
        20,
    );

    return (
        <div>
            <Text variant="apheleia-body-large" className={styles["finance-representative-disclaimer"]}>
                <CarConfigLabel label="carConfigExchangeRate" params={{ primaryPrice, secondaryPrice }} />
            </Text>
        </div>
    );
};

export default ExchangeRate;
